export default __webpack_public_path__ + "static/media/instant-noodles.22c30004.png";